export default __webpack_public_path__ + "static/Cover-a76f8434d2277096808fa36f986aaf61.jpg";